import React from 'react';
import { formatNumber } from '../../../core/helpers/format-number';

import { TableCol6Model } from '../../../core/models/tables';

interface INuclearOutagesTable {
  data: TableCol6Model[];
}

export default function NuclearOutagesTable({ data }: INuclearOutagesTable): JSX.Element {
  return (
    <div className="NuclearOutagesTable">
      <h3>Nuclear Outages (MW)</h3>
      <div className="table-container">
        <table className="total-table total-table-stripped table-lg">
          <thead>
            <tr>
              <th>Name</th>
              <th>Category</th>
              <th>Capacity</th>
              <th>
                Impact <br /> Value (*)
              </th>
              <th>
                Actual <br /> Capacity
              </th>
              <th>Start Date</th>
              <th>Duration (days)</th>
            </tr>
          </thead>
          <tbody>
            {data.map((nuclearOutage, index) => (
              <tr key={index}>
                <td>{nuclearOutage.col1}</td>
                <td>{nuclearOutage.col2}</td>
                <td>{formatNumber(nuclearOutage.col3)}</td>
                <td>{formatNumber(nuclearOutage.col4)}</td>
                <td>{formatNumber(nuclearOutage.col5)}</td>
                <td>{nuclearOutage.col6}</td>
                <td>{nuclearOutage.col7}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="note">* Only outages of 50 MW or higher are shown</p>
    </div>
  );
}
